<!-- 用户中心（教师端） -->
<template>
  <div class="el-UserCenter">
    <el-row class="content_block mb30">
      <TitleInfo title="用户中心" :titleImg="yonghuzx"></TitleInfo>
      <el-row style="min-height: 320px; overflow: auto">
        <el-col :span="8">
          <el-row class="user_info">
            <el-row class="tc">
              <el-image class="user_img c_p" :src="user"></el-image>
              <el-row>
                <el-col :span="12">
                  <el-upload
                    class="avatar-uploader"
                    :action="action"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :before-upload="beforeAvatarUpload"
                  >
                    <el-button class="mr10" type="primary">重新上传</el-button>
                  </el-upload>
                </el-col>
                <el-col :span="12">
                  <el-button class="ml10" type="success" @click="wxbd"
                    >绑定微信</el-button
                  >
                </el-col>
              </el-row>
            </el-row>
          </el-row>
        </el-col>
        <el-col :span="8">
          <el-col :span="24">
            <el-row class="xq_user_info">
              <el-row class="list">
                <p class="head_user m0 p10">
                  <el-image class="img" :src="zhanghao"></el-image>
                  账号信息
                </p>
                <el-row class="pt10 pl30 pb20">
                  <p>登录账号：{{ userInfo.code }}</p>
                  <p>登录密码：******</p>
                  <p>登录次数：{{ userInfo.loginCount }}</p>
                  <p>
                    最近登录时间：{{
                      $timeFormat(userInfo.lastLoginTime, "yyyy-MM-dd HH:mm:ss")
                    }}
                  </p>
                  <p>&nbsp;</p>
                  <el-row class="tc">
                    <el-button icon="el-icon-edit-outline" @click="editAccount"
                      >编辑</el-button
                    >
                  </el-row>
                </el-row>
              </el-row>
            </el-row>
          </el-col>
          <el-col :span="24">
            <el-row class="xq_user_info">
              <el-row class="list">
                <p class="head_user m0 p10">
                  <el-image class="img" :src="ziliao"></el-image>
                  基本资料
                </p>
                <el-row class="pt10 pl30 pb20">
                  <p>学校：{{ ruleInfo.universitiesCollegesName }}</p>
                  <p>院系：{{ ruleInfo.universityFacultyName }}</p>
                  <p>班级：{{ ruleInfo.classNames }}</p>
                  <p>所在地：{{ ruleInfo.universitiesCollegesAddress }}</p>
                  <el-row class="tc">
                    <el-button icon="el-icon-edit-outline" disabled
                      >编辑</el-button
                    >
                  </el-row>
                </el-row>
              </el-row>
            </el-row>
          </el-col>
        </el-col>
        <el-col :span="8">
          <el-col :span="24">
            <el-row class="xq_user_info">
              <el-row class="list">
                <p class="head_user m0 p10">
                  <el-image class="img" :src="yonghuxx"></el-image>
                  用户信息
                </p>
                <el-row class="pt10 pl30 pb20">
                  <p>姓名：{{ identityInfo.teacherName }}</p>
                  <p>性别：{{ $retSex(identityInfo.teacherGender) }}</p>
                  <p>联系电话：{{ identityInfo.teacherMobile }}</p>
                  <p>邮箱：{{ identityInfo.teacherEmail }}</p>
                  <p>
                    院校授权码：{{ identityInfo.universitiesCollegesAuthCode }}
                  </p>
                  <el-row class="tc">
                    <el-button icon="el-icon-edit-outline" @click="editUser"
                      >编辑</el-button
                    >
                  </el-row>
                </el-row>
              </el-row>
            </el-row>
          </el-col>
        </el-col>
      </el-row>
    </el-row>

    <!-- 编辑账号信息 -->
    <el-dialog
      title="修改账号信息"
      :visible.sync="editAccount_show"
      width="600px"
    >
      <span slot="title">
        <i class="el-icon-edit-outline edit_info_img"></i>修改账号信息
      </span>
      <el-row>
        <el-form ref="form" :model="userForm" label-width="80px">
          <el-form-item label="账号">
            <el-input v-model="userInfo.code" disabled></el-input>
          </el-form-item>
          <el-form-item label="旧密码">
            <el-input
              v-model="userForm.oldPaw"
              type="password"
              show-password
              placeholder="请输入旧密码"
            ></el-input>
          </el-form-item>
          <el-form-item label="新密码">
            <el-input
              v-model="userForm.newPaw1"
              type="password"
              show-password
              placeholder="请输入新密码"
            ></el-input>
          </el-form-item>
          <el-form-item label="确认密码">
            <el-input
              v-model="userForm.newPaw2"
              type="password"
              show-password
              placeholder="请确认密码"
            ></el-input>
          </el-form-item>
        </el-form>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editAccount_show = false">取 消</el-button>
        <el-button type="primary" @click="submitEditAccount">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 编辑用户信息 -->
    <el-dialog title="修改用户信息" :visible.sync="editUser_show" width="600px">
      <span slot="title">
        <i class="el-icon-edit-outline edit_info_img"></i>修改用户信息
      </span>
      <el-row>
        <el-form ref="form" :model="userForm" label-width="80px">
          <el-form-item label="姓名">
            <el-input
              v-model="userForm.teacherName"
              placeholder="请输入姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="性别">
            <el-select
              clearable
              v-model="userForm.teacherGender"
              placeholder="请选择性别"
            >
              <el-option label="男" value="MAN"></el-option>
              <el-option label="女" value="WOMAN"></el-option>
              <el-option label="保密" value="UN_KNOW"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="电话">
            <el-input
              v-model="userForm.teacherMobile"
              maxlength="11"
              placeholder="请输入电话"
            ></el-input>
          </el-form-item>
          <el-form-item label="验证码">
            <el-input
              v-model="userForm.verificationCode"
              placeholder="请输入验证码"
            >
              <template #append>
                <el-button type="primary" @click="sendVerificationCode">{{
                  time ? "" + time + "秒后重新获取" : "获取验证码"
                }}</el-button></template
              >
            </el-input>
          </el-form-item>
          <el-form-item label="邮箱">
            <el-input
              v-model="userForm.teacherEmail"
              placeholder="请输入邮箱"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="QQ">
            <el-input v-model="userForm.qq" placeholder="请输入QQ"></el-input>
          </el-form-item>
          <el-form-item label="微信">
            <el-input v-model="userForm.wx" placeholder="请输入微信"></el-input>
          </el-form-item>
          <el-form-item label="所在地">
            <el-input v-model="userForm.szd" show- placeholder="请输入所在地"></el-input>
          </el-form-item> -->
        </el-form>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editUser_show = false">取 消</el-button>
        <el-button type="primary" @click="submitEditUser">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="微信绑定"
      @close="closeDialog"
      :visible.sync="wxShow"
      width="500px"
    >
      <div style="text-align: center">
        <div
          style="
            border: 1px solid #a9a6a6;
            width: 120px;
            margin: 0 auto;
            padding: 10px;
          "
        >
          <el-image style="width: 120px; height: 120px" :src="qrCode">
            <div slot="placeholder" class="image-slot">
              加载中<span class="dot">...</span>
            </div>
          </el-image>
        </div>
        <p style="color: #409eff">微信扫一扫绑定</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="wxShow = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import TitleInfo from "@/components/TitleInfo"; //页面头部
export default {
  name: "UserCenter",
  components: {
    TitleInfo,
  },
  data() {
    return {
      action: this.$baseUrl + "/api/file/update.do",
      yonghuzx: require("../../images/asset/geren@2x.png"),
      user: this.$getHeadImg(),
      zhanghao: require("../../images/user/zhanghao@2x.png"),
      huoyued: require("../../images/user/huoyued@2x.png"),
      yonghuxx: require("../../images/user/yonghuxx@2x.png"),
      ziliao: require("../../images/user/ziliao@2x.png"),
      editAccount_show: false,
      userInfo: {},
      identityInfo: {},
      ruleInfo: {},
      editUser_show: false,
      userForm: {
        teacherName: "",
        oldPaw: "",
        newPaw1: "",
        newPaw2: "",
      },
      qrCode: "",
      wxShow: false,
      timeIn: null,
      sign: "stop", //用于时候继续轮询
      time: 0,
    };
  },
  created() {
     setTimeout(() => {
     if(localStorage.getItem("hasBoundMobile")=='false'){
      this.editUser() 
     }
    }, 1000);
  },
  mounted() {
    this.getInfo();
    //this.addSystem();
  },
  methods: {
    handleAvatarSuccess(res, file) {
      if (res.code == 0) {
        this.$post("/api/core/user/edit.do", { headImg: res.data.url }).then(
          (ret) => {
            if (ret.code == 0) {
              this.user = this.$isHttp(res.data.url);
              this.identityInfo.headImg = res.data.url;
              this.$ls.set(this.$getKeyInfo("userInfo"), this.identityInfo);
              this.$message({ message: "上传成功！", type: "success" });
            } else {
              this.$message({ message: ret.msg, type: "error" });
            }
          }
        );
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG/PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 5MB!");
      }
      return isJPG && isLt2M;
    },
    getInfo() {
      //获取信息
      this.$get("/api/teacher/userCenter.do").then((ret) => {
        if (ret.code == 0) {
          this.userInfo = ret.data.userInfo;
          this.identityInfo = ret.data.teacherInfo;
             if (this.identityInfo.teacherMobile !==null&& this.identityInfo.teacherMobile !== "") {
                localStorage.removeItem("hasBoundMobile");
              }
          if (!this.$isEmpty(this.userInfo.headImg)) {
            this.user = this.$isHttp(this.userInfo.headImg);
          }
          this.ruleInfo = ret.data.ruleInfo;
        } else {
          this.$message({ message: ret.msg, type: "error" });
        }
      });
    },
    editAccount() {
      //编辑账号信息
      this.userForm = {
        teacherName: "",
        oldPaw: "",
        newPaw1: "",
        newPaw2: "",
      };
      this.editAccount_show = true;
    },
    submitEditAccount() {
      //确认编辑账号信息
      if (this.$isEmpty(this.userForm.oldPaw)) {
        this.$message({ message: "请输入旧密码！", type: "warning" });
        return;
      }
      if (this.$isEmpty(this.userForm.newPaw1)) {
        this.$message({ message: "请输入新密码！", type: "warning" });
        return;
      }
      if (this.$isEmpty(this.userForm.newPaw2)) {
        this.$message({ message: "请输入确认密码！", type: "warning" });
        return;
      }
      if (this.userForm.newPaw1 != this.userForm.newPaw2) {
        this.$message({ message: "新密码和确认密码不相同！", type: "warning" });
        return;
      }
      let param = {
        password: this.userForm.oldPaw,
        newPassword: this.userForm.newPaw2,
      };
      this.$post("/core/user/changePassword.json", param).then((ret) => {
        if (ret.code == 0) {
          this.editAccount_show = false;
          this.$message({ message: "修改成功！", type: "success" });
        } else {
          this.$message({ message: ret.msg, type: "error" });
        }
      });
    },
    editUser() {
      //编辑用户信息
      this.userForm = this.identityInfo;
      this.editUser_show = true;
    },
    submitEditUser() {
      //确认编辑用户信息
      if (this.$isEmpty(this.userForm.teacherName)) {
        this.$message({ message: "请输入姓名！", type: "warning" });
        return;
      }
      if (this.$isEmpty(this.userForm.teacherMobile)) {
        this.$message({ message: "请输入手机号！", type: "warning" });
        return;
      }
      this.$post("/smsCheck.json", {
        phoneNumber: this.userForm.teacherMobile,
        smsCode: this.userForm.verificationCode,
      }).then((ret) => {
        if (ret.code == 500)
          return this.$message({ message: ret.msg, type: "error" });
        clearInterval(this._timer);
        this.time = 0;
        let param = {
          teacherName: this.userForm.teacherName,
          teacherId: this.identityInfo.teacherId,
          teacherGender: this.userForm.teacherGender,
          teacherMobile: this.userForm.teacherMobile,
          teacherEmail: this.userForm.teacherEmail,
        };
        this.$post("/jlw/teacher/edit.json", param).then((ret) => {
          if (ret.code == 0) {
            this.editUser_show = false;
            this.getInfo();
            this.$message({ message: "修改成功！", type: "success" });
          } else {
            this.$message({ message: ret.msg, type: "error" });
          }
        });
      });
    },
    wxbd() {
      this.qrCode = "";
      this.sign = "loading";
      this.$get("/wx/api/getBindLoginQrCode")
        .then((ret) => {
          if (ret.code == 0) {
            // this.wxShow = true;
            // this.qrCode = ret.data.imgUrl;
            // this.getLoginAndBindStatus(ret.data.userId);
               const qrWindow = window.open(ret.data.qrCodeUrl, "_blank");
          const ws = new WebSocket("wss://zycloud.sztzjy.com/server/ws/" + ret.data.state);
          // 接收消息
            ws.onmessage = (e) => {
               if (qrWindow && !qrWindow.closed) {
                 qrWindow.close();
               }
               this.$message({ message:  e.data, type:e.data.includes("成功") ? "success" : "warning" });
                   
               };
          } else {
            this.$message({ message: ret.msg, type: "warning" });
          }
        })
        .catch((err) => {});
    },
    getLoginAndBindStatus(userId) {
      //获取扫码状态
      this.$get("/wx/api/getLoginAndBindStatus", {
        type: "bind",
        userId: userId,
      })
        .then((ret) => {
          if (ret.status == "warning" && this.sign == "loading") {
            //等待回应时继续轮询访问
            setTimeout(() => {
              //未返回
              this.getLoginAndBindStatus(userId);
            }, 2000);
          } else if (this.sign == "loading") {
            this.sign = "stop";
            if (ret.status == "success") {
              //成功
              this.wxShow = false;
              this.$message({ message: "绑定成功！", type: "success" });
            } else {
              this.$message({ message: ret.token, type: "warning" });
            }
          }
        })
        .catch((err) => {});
    },
    closeDialog() {
      //关闭时停止轮询
      this.sign = "stop";
    },
    addSystem() {
      //模块使用统计
      //模块使用时间 开始
      const timeNum = this.$ls.get("timeNum"); //获取统一
      this.timeIn = setInterval(() => {
        let param = {
          firstName: "用户中心", //一级名称
          secondName: "用户中心", //二级名称
          useDuration: timeNum / 1000 / 60, //单次使用时长（单位：分钟）
        };
        this.$addSystemUseLog(param);
      }, timeNum);
      // 结束
    },
    sendVerificationCode() {
      if (this.$isEmpty(this.userForm.teacherMobile)) {
        this.$message.warning("请输入手机号！");
        return;
      }
      // 对手机号进行校验
      const phoneReg = /^1[3-9]\d{9}$/;
      if (!phoneReg.test(this.userForm.teacherMobile)) {
        this.$message.warning("请输入正确的11位手机号！");
        return;
      }
      if (this.time > 0 && this.time < 60) {
        this.$message.warning(`请${this.time}秒后再获取验证码！`);
        return;
      }
      this.$post("/sendCode.json", {
        phoneNumber: this.userForm.teacherMobile,
        type: 2,
      })
        .then((ret) => {
          if (ret.code == 0) {
            this.$message({ message: "验证码已发送！", type: "success" });
            this.time = 60;
            this.startCountdown();
          }
        })
        .catch((err) => {});
    },
    startCountdown() {
      if (this._timer) {
        clearInterval(this._timer);
      }
      this._timer = setInterval(() => {
        if (this.time > 0) {
          this.time--;
        } else {
          clearInterval(this._timer);
          this._timer = null;
        }
      }, 1000);
    },
  },
  beforeDestroy() {
    clearInterval(this.timeIn); //关闭定时
  },
};
</script>
 <style  lang="less">
.el-UserCenter {
  padding: 20px 20px 0;
  .content_block {
    background-color: #ffffff;
  }
  .user_info {
    background-color: #e9fcfd;
    height: 800px;
    max-width: 540px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 80%;
  }
  .xq_user_info {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 400px;
    .list {
      border: 1px solid #d3d3d3;
      width: 400px;
    }
    .img {
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }
    .head_user {
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #eff2f7;
    }
  }
  .edit_info_img {
    color: #f9c75a;
    margin-right: 10px;
    font-size: 20px;
  }
  .user_img {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    margin-bottom: 40px;
  }
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/pages/user/TUserCenter.vue